module.exports = __webpack_public_path__ + "files/10ef350a515367abe92ae5e585ed83a2.png";